import React, { Fragment, useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import 'react-toastify/dist/ReactToastify.css';
import { Link, useNavigate, useLocation } from "react-router-dom";
import Spinner from "../FieldComponets/Spinner";
import { ErrorMessage } from '@hookform/error-message';
import { useDispatch, useSelector } from 'react-redux';
import ToastDefault from "../FieldComponets/Toast";
import PageLayout from "../Layouts/PageLayout";
import * as Yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { VALIDATION_MESSAGE } from "../../Constants/Constants";
import { decodeID, getLastURL } from "../../utils/Helper";
import { AtributeDetailsAction , AtributeUpdateAction  } from "../../Redux/Action/AtributeAction";
import { FormattedMessage, useIntl } from "react-intl";




interface FormInputs {
  attrib_type: string,
  title: string,
  edit_id?: string,

}
function CancelManagementEdit() {
  const dispatch = useDispatch<any>();
  const navigate = useNavigate()
  const intl = useIntl();
  const Atributedata = useSelector((state: any) => state.AtributeDetailsState?.data?.data)
  const Atributesupdatedata = useSelector((state: any) => state.AtributeUpdateState)

  const location = useLocation();
  const editId = getLastURL(location);
  const log_in = useSelector((state: any) => state.AdminLogInState)
  const [loading, setLoading] = useState(false)

  const formSchema: any = Yup.object().shape({
    title: Yup.string()
      .required(intl.formatMessage({ id: "please_enter_title" }))
      .trim()
      .min(2, intl.formatMessage({ id: "title_min_length" }))
      .max(255, intl.formatMessage({ id: "title_max_length" })),

      attrib_type: Yup.string()
      .required(intl.formatMessage({ id: "please_enter_attribute_type" }))
      .trim()
  });
  const { register, formState: { errors }, handleSubmit, watch, setValue } = useForm<FormInputs>({
    resolver: yupResolver(formSchema),
  });
  const onSubmit = (data: FormInputs) => {
    data.edit_id = Atributedata.id
    dispatch(AtributeUpdateAction(data))
  };
  useEffect(() => {
    if (Atributesupdatedata.status) {
      setTimeout(() => {
        navigate("/cancel-management-list")
      }, 1000);
    }
  }, [Atributesupdatedata])

  useEffect(() => {
    setLoading(true)
    var params = {
      detail_id: decodeID(editId)
    };
    dispatch(AtributeDetailsAction(params))
    setTimeout(() => {
      setLoading(false)
    }, 400);
  }, [])
  useEffect(() => {
    if (Atributedata) {
      setLoading(false);
      setValue("title", Atributedata.title);
      setValue("attrib_type", Atributedata.attrib_type);
    }
  }, [Atributedata, setValue]);
  useEffect(() => {
    return () => {
      dispatch(AtributeUpdateAction('RESET'));
    }
  }, [])
  return (
    <Fragment>
      {loading || log_in?.loading ? <Spinner /> : ""}
      <PageLayout
        title={<FormattedMessage id="cancel_reason_update" />}
        breadcrumbs={{
          secLast: { 'link': '/atribute-list', 'name': <FormattedMessage id="cancel_reason" /> },
        }}
        buttons={[
          { url: '/class-add', className: 'btn btn-primary', text: '+ Add Sponsors', show: false }, // This button will be shown
        ]}
      >


        <div className="mt-4">
          <form onSubmit={handleSubmit(onSubmit)}>
            <div className="row gy-4 mb-4">
              <div className="col-md-6">
                <label htmlFor="username" className="form-label"><FormattedMessage id="title" /></label>
                <input type="text" className="form-control mb-0" id="title" defaultValue={Atributedata?.title} placeholder={intl.formatMessage({ id: "enter_title" })} {...register("title", {
                  required: intl.formatMessage({ id: "please_enter_title" }),

                })}
                  onInput={(e: any) => {
                    // e.target.value = e.target.value.replace(/\s/g, '');
                    setValue("title", e.target.value)
                  }}
                />
                <ErrorMessage
                  errors={errors}
                  name="title"
                  render={({ message }) => <p className="mt-1" style={{ color: 'red' }}>{message}</p>}
                />
              </div>
              <div className="col-md-6">
                <label htmlFor="attrib_type" className="form-label"><FormattedMessage id="attribute_type" /></label>
                <select
                  id="attrib_type"
                  className="form-control profile-approve-dropdown"
                  {...register("attrib_type", {
                    required: intl.formatMessage({ id: "please_select_attribute_type" })
                  })}
                  onInput={(e: any) => {
                    setValue("attrib_type", e.target.value)
                  }}
                >
                  <option value="">{intl.formatMessage({ id: "select_type" })}</option>
                  <option value="2" selected={Atributedata?.attrib_type == "2" ? true : false } >{intl.formatMessage({ id: "cancel_reason" })}</option>
                </select>
                <ErrorMessage
                  errors={errors}
                  name="attrib_type"
                  render={({ message }) => <p className="mt-1" style={{ color: 'red' }}>{message}</p>}
                />
              </div>
              <div className="col-md-2 col-sm-6 col-12">
                <button type="submit" className="btn btn-primary waves-effect waves-light w-100"><FormattedMessage id="save" /></button>
              </div>
            </div>

          </form>
        </div>
        <ToastDefault />
      </PageLayout>
    </Fragment>
  );
}

export default CancelManagementEdit